export const AVS_CREATOR_ADDR = '0xbd21f6ef8f5f5b38a49c67bab79ba6e710611bb9';
export const AVS_DIRECTORY_ADDR = '0x055733000064333caddbc92763c58bf0192ffebf';
export const REWARDS_COORDINATOR_ADDR = '0xacc1fb458a1317e886db376fc8141540537e68fe';
export const DELEGATION_MANAGER_ADDR = '0xA44151489861Fe9e3055d95adC98FbD462B948e7';
export const STG_AGGREGATOR_ADDR = '0x8210bbaaDC83E334d8e980e0A6b4A8DdAAd3ec5F';
export const PROD_AGGREGATOR_ADDR = '0x499d96c1e1B81231af31F746DBAbBC0fD3516FFd';
